import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Navbar.css'; 


function Navbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [navOpen, setNavOpen] = useState(false);

  const handleDropdownToggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleDropdownClose = () => {
    setDropdownOpen(false);
    setNavOpen(false); // Close navbar when selecting a menu item
  };

  const handleNavToggle = () => {
    setNavOpen(!navOpen);
  };

  useEffect(() => {
    const handleExpandDropdown = () => {
      if (window.innerWidth < 992) {
        setNavOpen(true); // Open navbar if it's collapsed
      }
      setDropdownOpen(true); // Expand Services dropdown
    };

    window.addEventListener('expandServicesDropdown', handleExpandDropdown);

    return () => {
      window.removeEventListener('expandServicesDropdown', handleExpandDropdown);
    };
  }, []);

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <Link className="navbar-brand" to="/" style={{ paddingLeft: "5px" }}>
        Legal Trails
      </Link>

      <button className="navbar-toggler" type="button" onClick={handleNavToggle}>
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className={`collapse navbar-collapse ${navOpen ? 'show' : ''}`} id="navbarNav">
        <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <Link className="nav-link" to="/" onClick={() => setNavOpen(false)}>Home</Link>
          </li>

          <li className="nav-item dropdown">
            <Link className="nav-link dropdown-toggle" to="#" id="navbarDropdown" role="button" onClick={handleDropdownToggle}>
              Services
            </Link>
            <div className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`} aria-labelledby="navbarDropdown">
              <Link className="dropdown-item" to="/CorporateCommercialLaw" onClick={handleDropdownClose}>Corporate Law</Link>
              <Link className="dropdown-item" to="/CriminalLaw" onClick={handleDropdownClose}>Criminal Law</Link>
              <Link className="dropdown-item" to="/MatrimonialDisputes" onClick={handleDropdownClose}>Matrimonial Law</Link>
              <Link className="dropdown-item" to="/TaxationLaw" onClick={handleDropdownClose}>Taxation Law</Link>
              <Link className="dropdown-item" to="/IntellectualPropertyLaw" onClick={handleDropdownClose}>Intellectual Property Law</Link>
              <Link className="dropdown-item" to="/RealEstateLaw" onClick={handleDropdownClose}>Real Estate Law</Link>
              <Link className="dropdown-item" to="/ITAndCyberLaw" onClick={handleDropdownClose}>IT Law</Link>
              <Link className="dropdown-item" to="/ArbitrationLaw" onClick={handleDropdownClose}>Arbitration</Link>
              <Link className="dropdown-item" to="/ConsumerProtectionLaw" onClick={handleDropdownClose}>Consumer Law</Link>
              <Link className="dropdown-item" to="/StatutoryAndGovernmentApprovals" onClick={handleDropdownClose}>Statutory Law</Link>
              <Link className="dropdown-item" to="/IndustrialLabourAndEmployment" onClick={handleDropdownClose}>Labor Law</Link>
            </div>
          </li>

          <li className="nav-item">
            <Link className="nav-link" to="/Team" onClick={() => setNavOpen(false)}>Our Team</Link>
          </li>

          <li className="nav-item">
            <Link className="nav-link" to="/contact" onClick={() => setNavOpen(false)}>Contact Us</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
